/* tslint:disable */
const isDeepEquals = (x, y) => {
    for (const p in x) {
        if (!x.hasOwnProperty(p)) {
            continue; // other properties were tested using x.constructor === y.constructor
        }
        if (!y.hasOwnProperty(p)) {
            return false; // allows to compare x[ p ] and y[ p ] when set to undefined
        }
        if (x[p] === y[p]) {
            continue; // if they have the same strict value or identity then they are equal
        }
        if (typeof (x[p]) !== 'object') {
            return false; // Numbers, Strings, Functions, Booleans must be strictly equal
        }
        if (!isEquals(x[p], y[p])) {
            return false;
        }
    }
    for (const p in y) {
        if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) {
            return false;
        }
    }
    return true;
};

export const isEquals = (x, y) => {
    if (x === y) {
        return true; // if both x and y are null or undefined and exactly the same
    } else if (!(x instanceof Object) || !(y instanceof Object)) {
        return false; // if they are not strictly equal, they both need to be Objects
    } else if (x.constructor !== y.constructor) {
        // they must have the exact same prototype chain, the closest we can do is
        // test their constructor.
        return false;
    } else {
        return isDeepEquals(x, y);
    }
};

export const isEmpty = value => !value || value.replace(/\s/g, '').length === 0;

export const normalizeLibelle = (value: string) => value.replace(/[^a-zA-Z\u00C0-\u017F0-9]\./g, '_');

/**
 * @TODO: deepCasAs
 */
export const castAs = <T extends object>(value: object, TCreator: { new(...args: any[]): T }): T => {

    // if we already have the correct class skip the cast
    if (!value || value instanceof TCreator) {
        return value as T;
    }
    // create a new object (create), and copy over all properties (assign)
    const target: T = new TCreator();
    Object.assign(target, value);
    return target;
};

export const saveOrOpenRawFile = (rawFile: Blob | string, fileName: string) => {
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(rawFile, normalizeLibelle(fileName));
    } else {
        const url = URL.createObjectURL(rawFile);

        const downloadLink = document.createElement('a');
        downloadLink.href = url;
        downloadLink.target = '_blank';
        downloadLink.download = normalizeLibelle(fileName);
        document.body.appendChild(downloadLink);

        downloadLink.click();

        document.body.removeChild(downloadLink);
    }
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/core/util.ts